import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { TentTree } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const formatRand = (n) => `R${Math.round(n).toLocaleString("en-ZA").replace(/,/g, " ")}`;

export const DonationImpactBadge = ({ className = "" }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/donations/total`)
      .then((r) => setData(r.data))
      .catch(() => {});
  }, []);

  if (!data) return null;

  const pct = Math.min(100, Math.round((data.total_zar / data.goal_zar) * 100));

  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.3, duration: 0.6 }}
      className={`w-full max-w-md rounded-3xl border border-teal/20 bg-white/80 p-5 shadow-[0_12px_36px_-18px_rgba(15,118,110,0.5)] backdrop-blur ${className}`}
      data-testid="donation-impact-badge"
    >
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-teal text-sand">
          <TentTree size={16} />
        </span>
        <p className="font-heading text-sm font-bold text-coal" data-testid="donation-impact-text">
          {data.count === 0 ? (
            <>Be the first to fuel {data.goal_label}</>
          ) : (
            <>
              {formatRand(data.total_zar)} raised
              <span className="font-normal text-coal-muted"> of {formatRand(data.goal_zar)} for {data.goal_label}</span>
            </>
          )}
        </p>
      </div>
      <div
        className="mt-3 h-2.5 w-full overflow-hidden rounded-full bg-sand-dark/60"
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Donation goal progress: ${pct} percent`}
        data-testid="donation-goal-bar"
      >
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${Math.max(pct, 2)}%` }}
          transition={{ delay: 1.7, duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          className="h-full rounded-full bg-gradient-to-r from-teal to-ember"
        />
      </div>
      <p className="mt-2 text-xs text-coal-muted" data-testid="donation-goal-text">
        {data.count === 0
          ? "Every rand takes a Grade 12 learner closer to camp."
          : `${pct}% there, thanks to ${data.count} generous ${data.count === 1 ? "donor" : "donors"}.`}
      </p>
    </motion.div>
  );
};
